import { render, staticRenderFns } from "./draftContract.vue?vue&type=template&id=2b885905&scoped=true"
import script from "./draftContract.vue?vue&type=script&lang=js"
export * from "./draftContract.vue?vue&type=script&lang=js"
import style0 from "./draftContract.vue?vue&type=style&index=0&id=2b885905&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b885905",
  null
  
)

export default component.exports